import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';

const PREFIX = 'CancelTripLegUnavailableDialog';

const classes = {
  loadingContainer: `${PREFIX}-loading-container`,
  errorContainer: `${PREFIX}-error-container`,
  errorActions: `${PREFIX}-error-actions`,
};

const StyledDialog = styled(Dialog)(() => ({
  [`& .${classes.loadingContainer}`]: {
    textAlign: 'center',
    minHeight: 200,
    minWidth: 444,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  [`& .${classes.errorContainer}`]: {
    width: 444,
  },
  [`& .${classes.errorActions}`]: {
    justifyContent: 'end',
    '& button': {
      flex: 'none',
      width: 144,
    },
  },
}));

interface CancelTripLegUnavailableDialogProps {
  dialogOpen: boolean;
  loadingSyncedTripLeg: boolean;
  showUnavailableMessage: boolean;
  onClose: () => void;
}

export default function CancelTripLegUnavailableDialog({
  dialogOpen,
  loadingSyncedTripLeg,
  showUnavailableMessage,
  onClose,
}: CancelTripLegUnavailableDialogProps) {
  const t = useCommonTranslation();

  const renderLoadingContent = () => {
    return (
      <DialogContent>
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </DialogContent>
    );
  };

  const renderErrorContent = () => {
    return (
      <>
        <DialogTitle>{t('tripLegErrors.cancelDialogHeader')}</DialogTitle>
        <DialogContent>
          <Box className={classes.errorContainer}>
            <p>{t('tripLegErrors.cancelDialogTitle')}</p>
            <ul>
              <li>{t('tripLegErrors.time')}</li>
              <li>{t('tripLegErrors.provider')}</li>
              <li>{t('tripLegErrors.driver')}</li>
              <li>{t('tripLegErrors.offered')}</li>
            </ul>
            <p>
              {t('tripLegErrors.dialogFooter')} <b>{t('footer.phoneNumber')}</b>
            </p>
          </Box>
        </DialogContent>
        <DialogActions className={classes.errorActions}>
          <Button variant="contained" onClick={onClose}>
            {t('common.close')}
          </Button>
        </DialogActions>
      </>
    );
  };

  return (
    <StyledDialog open={dialogOpen}>
      {loadingSyncedTripLeg && renderLoadingContent()}
      {showUnavailableMessage && renderErrorContent()}
    </StyledDialog>
  );
}
